import { KeyParametersPanel } from '~/components/keyParameter/KeyParametersPanel';
import type { ReportDisplayReportItem } from '~/components/report/ReportDisplay/ReportItem';
import { WikiDescriptionText } from '~/components/wiki/lithostrat/WikiPageDescriptionText';

type Props = {
  group: Extract<
    NonNullable<ReportDisplayReportItem['bookmark']>['targetLithostratGroup'],
    { __typename?: 'LithostratGroup' }
  >;
};

export function ReportItemLithostratGroup({ group }: Props) {
  if (!group.wikiPage) {
    return <p>{group.description ?? group.name}</p>;
  }

  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2">
        <WikiDescriptionText wiki={group.wikiPage} />
      </div>

      <div>
        <KeyParametersPanel
          keyParameters={group.wikiPage.keyParameters ?? []}
        />
      </div>
    </div>
  );
}
